function ResetZoomOnReload() {
    const resetZoom = () => {
        document.body.style.zoom = 1;
    }

    window.onload = resetZoom;

    return null;
}

export default ResetZoomOnReload;
